export const PLATFORM_MAINTENANCE_POLL_INTERVAL = 60000;

export enum PLATFORM_MAINTENANCE_SCOPE_ENUM {
    ALL = 'all',
    PORTAL = 'portal'
}